import store from "../../store";
import { getFormatedDate } from "../../utils/common";
import toast from "react-hot-toast";
import { printBillViaBluetooth, hasBluetoothBillPrinterConfigured } from "../../services/BillPrintService";
import {
  THERMAL_BILL_BROWSER_BASE_CSS,
  openThermalBillPrintWindow,
} from "../../utils/thermalBillBrowserPrint.js";

export const Reprint = async (orderObj, printers = [], bluetoothOperations) => {
  const {
    billNo,
    amount,
    items,
    orderType,
    tableVPA,
    customerName,
    orderStatus,
    billStatus,
    paymentmethod,
    createdAt,
    billTxnLogs,
    tableDetails,
    couponMetadata,
  } = orderObj;

  const hotelData = {
    name: store.restaurantInfo.name,
    address: store.restaurantInfo.address,
    contact: store.restaurantInfo.contact,
    isGST: store.GST.active,
    GSTN: store.GST.gstNumber,
    FSSAI: store.GST.fassi_no,
  };

  const date = new Date(createdAt || new Date());
  const formattedDateTime = getFormatedDate(date);
  const table =
    tableDetails?.tableNo ||
    (tableVPA ? tableVPA.split("@")[0].replace("QRapid", "") : "NA");

  const validItems = items.filter(
    (item) => !item.isCancelled && item.quantity > 0
  );

  const billPrinters = printers.filter(
    (printer) =>
      printer.type !== "bluetooth" &&
      (printer.location === "bill" || printer.location === "all") &&
      printer.isConnected
  );

  const orderData = {
    validItems,
    hotelData,
    roomData: { table, room: tableDetails?.roomName || "NA" },
    billNo,
    billTxnLogs,
    customer: { name: customerName },
    GST: store.GST,
    formattedDateTime,
  };

  const bluetoothPrinted = await printBillViaBluetooth(orderData, printers);
  if (bluetoothPrinted) {
    return;
  }

  if (hasBluetoothBillPrinterConfigured(printers)) {
    return;
  }

  if (billPrinters && billPrinters.length > 0) {
    billPrinters.forEach((printer) => {
      printer.print(orderData, "bill");
    });
    return;
  }

  // fallback to HTML printing
  printBrowserBill(orderObj);
};

function transformBluetoothBill({
  cartItems,
  hotelData,
  roomData,
  billNo,
  billTxnLogs,
  customer,
  GST,
  formattedDateTime,
}) {
  const lines = [];
  lines.push(
    `<Text align='center' fontWidth='2' fontHeight='2'>${hotelData.name}</Text>`
  );
  lines.push(`<NewLine />`);
  if (hotelData.address)
    lines.push(`<Text align='center'>${hotelData.address}</Text>`);
  if (hotelData.contact)
    lines.push(`<Text align='center'>${hotelData.contact}</Text>`);
  if (billTxnLogs?.gst)
    lines.push(`<Text align='center'>GSTN: ${GST.gstNumber}</Text>`);
  if (GST.fassi_no)
    lines.push(`<Text align='center'>FSSAI: ${GST.fassi_no}</Text>`);

  lines.push(`<NewLine />`);
  lines.push(`<Text>Bill No: ${billNo}</Text>`);
  lines.push(`<Text>Date: ${formattedDateTime}</Text>`);
  lines.push(`<Text>Table: ${roomData.table}</Text>`);
  lines.push(`<NewLine />`);

  if (customer?.name && customer.name !== "NA")
    lines.push(`<Text>Customer: ${customer.name}</Text>`);

  lines.push(`<NewLine />`);
  lines.push(`<Text align='center'>Items</Text>`);
  cartItems.forEach((item) => {
    const addonsList = item.addOn || item.addOns || item.addons || [];
    const addonSum = addonsList.reduce((a, b) => a + Number(b.price || 0), 0);
    const displayPrice = Number(item.price);
    const name = `${item.name}${
      item.variantName ? " - " + item.variantName : ""
    }`;
    const total = ((displayPrice + addonSum) * Number(item.quantity)).toFixed(2);
    lines.push(`<Text>${name}</Text>`);
    if (addonsList.length > 0) {
      addonsList.forEach((a) => {
        lines.push(`<Text>  * ${a.name} (₹${a.price})</Text>`);
      });
    }
    lines.push(
      `<Text>Qty: ${item.quantity} | ₹${displayPrice} | Amt: ₹${total}</Text>`
    );
  });

  lines.push(`<NewLine />`);
  lines.push(`<Text>Sub Total: ₹${billTxnLogs.subTotal.toFixed(2)}</Text>`);
  if (billTxnLogs.discountFlat > 0)
    lines.push(
      `<Text>Flat Discount: ₹${billTxnLogs.discountFlat.toFixed(2)}</Text>`
    );
  if (billTxnLogs.discountPercent > 0)
    lines.push(
      `<Text>Discount (${billTxnLogs.discountPercent}%): ₹${(
        (billTxnLogs.discountPercent * billTxnLogs.subTotal) /
        100
      ).toFixed(2)}</Text>`
    );

  // Add Coupon Details
  if (couponMetadata && couponMetadata !== "NA") {
    lines.push(`<Text>Coupon (${couponMetadata.couponCode}): -₹${couponMetadata.couponValue}</Text>`);
  }

  if (billTxnLogs.gst) {
    lines.push(
      `<Text>CGST (${billTxnLogs.cgstPercent}%): ₹${billTxnLogs.cgst.toFixed(
        2
      )}</Text>`
    );
    lines.push(
      `<Text>SGST (${billTxnLogs.sgstPercent}%): ₹${billTxnLogs.sgst.toFixed(
        2
      )}</Text>`
    );
  }

  if (billTxnLogs.service && billTxnLogs.serviceAmount > 0) {
    lines.push(
      `<Text>Service Charge (${billTxnLogs.servicePercentage || 0}%): ₹${Number(
        billTxnLogs.serviceAmount
      ).toFixed(2)}</Text>`
    );
  }

  if (billTxnLogs.tip > 0)
    lines.push(`<Text>Tips: ₹${billTxnLogs.tip.toFixed(2)}</Text>`);

  lines.push(`<NewLine />`);
  lines.push(
    `<Text align='right'>GRAND TOTAL: ₹${billTxnLogs.total.toFixed(2)}</Text>`
  );
  lines.push(`<NewLine />`);
  if (billTxnLogs.gst && !billTxnLogs.gstExcluded)
    lines.push(`<Text align='center'>GST Included</Text>`);
  lines.push(`<Text align='center'>Powered by QRapid</Text>`);
  return lines.join("\n");
}

function printBrowserBill(orderObj) {
  // Extract data from the order object
  const {
    billNo,
    amount,
    items,
    orderType,
    tableVPA,
    customerName,
    orderStatus,
    billStatus,
    paymentmethod,
    createdAt,
    billTxnLogs,
    tableDetails,
  } = orderObj;

  // Get hotel data from store
  const hotelData = {
    name: store.restaurantInfo.name,
    address: store.restaurantInfo.address,
    contact: store.restaurantInfo.contact,
    isGST: store.GST.active,
    GSTN: store.GST.gstNumber,
    FSSAI: store.GST.fassi_no,
  };

  // Format date and time
  const dateTime = createdAt || new Date().toISOString();
  const date = new Date(dateTime);
  const formattedDateTime = getFormatedDate(date);
  // Get table information
  const table =
    tableDetails?.tableNo ||
    (tableVPA ? tableVPA.split("@")[0].replace("QRapid", "") : "NA");

  // Filter valid items
  const validItems = items.filter(
    (item) => !item.isCancelled && item.quantity > 0
  );

  // Calculate totals
  const subTotal =
    billTxnLogs?.subTotal || billTxnLogs?.beforeDiscountTotal || amount;
  const discount = billTxnLogs?.discount || 0;
  const discountFlat = billTxnLogs?.discountFlat || 0;
  const discountPercent = billTxnLogs?.discountPercent || 0;
  const cgst = billTxnLogs?.cgst || 0;
  const sgst = billTxnLogs?.sgst || 0;
  const tips = billTxnLogs?.tip || billTxnLogs?.tips || 0;
  const total = amount;

  // Build the HTML for the bill
  const billHtml = `
    <html>
      <head>
        <title>Bill Receipt - ${billNo}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          body {
            margin: 0;
            font-size: 14px;
            padding: 0;
            font-family: Arial, sans-serif;
            background-color: white;
            line-height: 1.3;
          }
          
          .bill-container {
            width: calc(100% - 12px);
          }
          
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-left { text-align: left; }
          .text-bold { font-weight: bold; }
          
          .divider {
            margin: 10px 0;
            border-top: 1px dashed #000;
          }
          
          .mb-12 { margin-bottom: 12px; }
          .mb-8 { margin-bottom: 8px; }
          .mb-6 { margin-bottom: 6px; }
          .mt-12 { margin-top: 12px; }
          
          .font-sm { font-size: 12px; }
          .font-md { font-size: 13px; }
          .font-lg { font-size: 15px; }
          .font-xl { font-size: 16px; }
          
          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .item-row td {
            padding: 4px 0;
            vertical-align: top;
          }
          
          .capitalize {
            text-transform: capitalize;
          }
          
          h2 {
            font-size: 18px;
            font-weight: bold;
            margin: 0 0 6px 0;
            line-height: 1.2;
          }
          
          p {
            margin: 0 0 6px 0;
            line-height: 1.2;
          }
          
          .header-info {
            font-size: 12px;
            line-height: 1.2;
            margin: 0 0 4px 0;
          }
          
          .bill-info-table td {
            font-size: 13px;
            padding: 2px 0;
          }
          
          .items-header th {
            font-size: 13px;
            padding: 4px 0;
            border-bottom: 1px solid #000;
            font-weight: bold;
          }
          
          .item-name {
            font-size: 13px;
            font-weight: bold;
            display: inline;
          }
          
          .variant-name {
            font-size: 13px;
            color: black;
            font-weight: normal;
            display: inline;
          }
          
          .summary-table td {
            padding: 2px 0;
            font-size: 13px;
          }
          
          .total-row {
            border-top: 2px solid #000;
            font-weight: bold;
            font-size: 15px;
          }
          
          .footer-text {
            font-size: 11px;
            text-align: center;
          }
        ${THERMAL_BILL_BROWSER_BASE_CSS}
        </style>
      </head>
      <body>
        <div class="bill-container">
          <!-- Header -->
          <div class="text-center mb-12">
            <h2>${hotelData.name}</h2>
            <p class="header-info">${hotelData.address}</p>
            ${
              hotelData.contact
                ? `<p class="header-info">${hotelData.contact}</p>`
                : ""
            }
            ${
              hotelData.isGST
                ? `<p class="header-info">GSTN: ${hotelData.GSTN || ""}</p>`
                : ""
            }
            ${
              hotelData.isGST
                ? `<p class="header-info">FSSAI: ${hotelData.FSSAI || ""}</p>`
                : ""
            }
            <div class="divider"></div>
          </div>

          <!-- Bill Info -->
          <div class="mb-12">
            <table class="bill-info-table">
              <tr>
                <td><span class="font-sm">Bill No: ${billNo}</span></td>
                <td class="text-right"><strong>Date:</strong> ${formattedDateTime}</td>
              </tr>
              <tr>
                <td><strong>Table: <span class="font-xl">${table}</span></strong></td>
                <td class="text-right"><strong>Status:</strong> ${billStatus}</td>
              </tr>
            </table>
            
            ${
              customerName !== "NA" && customerName !== ""
                ? `
              <div class="divider"></div>
              <div class="font-md">
                <p style="margin: 0 0 4px 0;"><strong>Customer:</strong> ${customerName}</p>
              </div>`
                : ""
            }
            
            <div class="divider"></div>
          </div>

          <!-- Items -->
          <div class="mb-12">
            <table>
              <thead>
                <tr class="items-header">
                  <th class="text-left">Item</th>
                  <th class="text-right" style="width: 40px;">Qty</th>
                  <th class="text-right" style="width: 60px;">Price</th>
                  <th class="text-right" style="width: 70px;">Amount</th>
                </tr>
              </thead>
              <tbody>
                ${validItems
                  .map(
                    (item) => {
                      const addonsList = item.addOn || item.addOns || item.addons || [];
                      const addonSum = addonsList.reduce((a, b) => a + Number(b.price || 0), 0);
                      const displayPrice = Number(item.price);
                      return `
                  <tr class="item-row">
                    <td class="text-left">
                      <div>
                        <span class="item-name">${item.name}</span>
                        ${
                          item.variantName
                            ? `<span class="variant-name"> - ${item.variantName}</span>`
                            : ""
                        }
                      </div>
                      ${
                        addonsList.length > 0
                          ? `<div style="font-size: 11px; color: #555; margin-top: 2px;">
                              ${addonsList.map(a => `<div style="margin-left: 5px;">* ${a.name} (₹${a.price})</div>`).join('')}
                             </div>`
                          : ""
                      }
                    </td>
                    <td class="text-right">${item.quantity}</td>
                      <td class="text-right font-md">
                      ${
                        item.discountAmount > 0
                          ? `<div>
                             
                              <span>${Number(
                                displayPrice - item.discountAmount
                              ).toFixed(2)}</span>
                                   <br/>
                               <span style="text-decoration: line-through; font-size: 11px; color: #666;">${Number(
                                 displayPrice
                               ).toFixed(2)}</span>
                         
                            </div>`
                          : Number(displayPrice).toFixed(2)
                      }
                    </td>
                    <td class="text-right font-md"><strong>${(
                      (Number(item.quantity) * (displayPrice - (Number(item.discountAmount) || 0) + addonSum))
                    ).toFixed(2)}</strong></td>
                  </tr>
                `;
                    }
                  )
                  .join("")}
              </tbody>
            </table>
            <div class="divider"></div>
          </div>

          <!-- Summary -->
          <div class="mb-12">
            <table class="summary-table">
              <tr>
                <td class="text-right"><strong>Sub Total:</strong></td>
                <td class="text-right" style="width: 80px;">₹${Number(
                  subTotal
                ).toFixed(2)}</td>
              </tr>
              
              ${
                discountFlat > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Flat Discount:</strong></td>
                  <td class="text-right">₹${Number(discountFlat).toFixed(
                    2
                  )}</td>
                </tr>
              `
                  : ""
              }
              
              ${
                discountPercent > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Discount (${discountPercent}%):</strong></td>
                  <td class="text-right">₹${Number(
                    (Number(discountPercent) * Number(subTotal)) / 100
                  ).toFixed(2)}</td>
                </tr>
              ` : ""}

              ${orderObj.couponMetadata && orderObj.couponMetadata !== "NA" ? `
                <tr>
                  <td class="text-right"><strong>Coupon (${orderObj.couponMetadata.couponCode}):</strong></td>
                  <td class="text-right">-₹${orderObj.couponMetadata.couponValue}</td>
                </tr>
              ` : ""}
              
              ${
                billTxnLogs?.gst && cgst > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>CGST (${
                    billTxnLogs.cgstPercent
                  }%):</strong></td>
                  <td class="text-right">₹${Number(cgst).toFixed(2)}</td>
                </tr>
                <tr>
                  <td class="text-right"><strong>SGST (${
                    billTxnLogs.sgstPercent
                  }%):</strong></td>
                  <td class="text-right">₹${Number(sgst).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }

              ${
                billTxnLogs?.service && billTxnLogs?.serviceAmount > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Service Charge (${
                    billTxnLogs.servicePercentage || 0
                  }%):</strong></td>
                  <td class="text-right">₹${Number(
                    billTxnLogs.serviceAmount
                  ).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              ${
                tips > 0
                  ? `
                <tr>
                  <td class="text-right"><strong>Tips:</strong></td>
                  <td class="text-right">₹${Number(tips).toFixed(2)}</td>
                </tr>
              `
                  : ""
              }
              
              <tr class="total-row">
                <td class="text-right" style="padding-top: 8px;"><strong>GRAND TOTAL:</strong></td>
                <td class="text-right" style="padding-top: 8px;">₹${Number(
                  total
                ).toFixed(2)}</td>
              </tr>
            </table>
          </div>

          <!-- Payment Info -->
          <div class="mb-12">
            <table class="font-md">
              <tr>
                <td><strong>Payment Method:</strong></td>
                <td class="text-right capitalize">${paymentmethod}</td>
              </tr>
            </table>
          </div>

          <!-- Footer -->
          <div class="mt-12">
            <div class="divider"></div>
            ${
              billTxnLogs?.gst && !billTxnLogs?.gstExcluded
                ? `<p class="footer-text mb-6">GST Already Included in Item Price</p>`
                : ""
            }
            <p class="footer-text">Powered by QRapid</p>
          </div>
        </div>

        <script>
          window.onload = function() {
            window.setTimeout(function() {
              window.print();
              window.setTimeout(function() {
                window.close();
              }, 500);
            }, 300);
          }
        </script>
      </body>
    </html>
  `;

  const opened = openThermalBillPrintWindow(billHtml);
  if (!opened.ok && opened.reason === "popup_blocked") {
    toast.error("Allow pop-ups for this site to open the print window.");
  }
}
